var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticStyle:{"height":"100%"},attrs:{"no-gutters":"","justify":"center","align":"center"}},[_c('v-avatar',{attrs:{"size":"38"}},[(_vm.avatar)?_c('v-img',{attrs:{"src":_vm.avatar}}):_c('v-icon',{attrs:{"color":"grey","x-large":""}},[_vm._v("perm_identity")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }